import { Injectable } from '@angular/core';
import { Route, UrlSegment, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService, AuthRole } from '../../../modules/auth';

@Injectable({
  providedIn: 'root'
})
export class AdminGuard  {

  constructor(
    private authService: AuthService,
    private router: Router
  ) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.isValid();
  }
  canLoad(
    route: Route,
    segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean {
    return this.isValid();
  }

  /**
   * Only Allow opening admin pages if user has not logged in and is admin.
   * If authenticated redirect to login instead.
   *
   * @returns true if user is admin.
   */
  isValid() {
    if (this.authService.isAuthenticated &&
      (this.authService.accessTokenObj.role === AuthRole.ADMIN)) {
      return true;
    }

    this.router.navigate(['/auth']);
    return true;
  }
}
